import IconsPreviewGrid from '@/UI/Icons/IconsPreviewGrid';

const IconsPreviewPage = () => {
  return <IconsPreviewGrid />;
};

export default IconsPreviewPage;
